import { inject, Injectable } from '@angular/core';
import { type Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import type { OffensePlea } from '../../../../core';

@Injectable({ providedIn: 'root' })
export class PleaService {
  private readonly http = inject(HttpClient);

  submit(pleas: Array<OffensePlea>, isPleaForm = false): Observable<unknown> {
    return this.http.put(`api/v1/tickets/workup/current/violations/plea?isPleaForm=${isPleaForm}`, pleas);
  }
}
